export default __webpack_public_path__ + "static/media/VbyV_en_2c.e3ef969c.svg";